import { css } from "styled-components";

export const UnitPriceRoot = css`
  color: #FFF;
  &:before {
    content: "";
    display: inline-block;
    background-image: url(/img/icon_gift--white.svg);
    background-size: cover;
    background-position: center;
    @media screen and (min-width: 961px) {
      width: 19px;
      height: 20px;
      margin-right: 4px;
    }
    @media screen and (max-width: 960px) {
      width: 16px;
      height: 17px;
      margin-right: 6px;
    }
  }
`;
export const UnitPriceAmount = css`
  font-style: italic;
  letter-spacing: .1em;
  @media screen and (min-width: 961px) {
    font-size: 30px;
    line-height: 26px;
  }
  @media screen and (max-width: 960px) {
    font-size: 24px;
    line-height: 20px;
  }
`;
export const UnitPriceUnit = css`
  padding-left: 4px;
  @media screen and (min-width: 961px) {
    font-size: 14px;
  }
  @media screen and (max-width: 960px) {
    font-size: 12px;
  }
`;
export const CourseNameCss = css`
  width: 100%;
  color: #FFFFFF;
  @media screen and (max-width: 960px) {
    font-size: 16px;
  }
  @media screen and (min-width: 961px) {
    font-size: 18px;
  }
  @media screen and (min-width: 1921px) {
    font-size: 20px;
  }
`;
export const NoteCss = css`
  line-height: 1.428em;
  @media screen and (max-width: 960px) {
    font-size: 11px;
  }
  @media screen and (min-width: 961px) {
    font-size: 13px;
  }
`;
